import { deleteClientCityToCityRequest } from "../../data/clientCityToCityApi";

export async function deleteClientCityToCityUseCase(id) {
  if (!id) {
    throw new Error("El id de la tarifa de ciudad es obligatorio.");
  }

  return await deleteClientCityToCityRequest(id);
}
